export default {
  meshes: [],
  meshesMeta: {},
  selectedMesh: null,
  expandedMeshes: [],
  expandedCuis: []
};